<template>
  <div class="gray-background-page">
    <div class="header">
      <router-link to="/" class="back-button">返回</router-link>
    </div>
    <div class="divider"></div>
    <div class="text">如下为开通银行网银查询的名单均为总行一级机构名单，仅供参考，具体使用条件和流程请咨询当地银行机构客服</div>
    <div class="text2">目前已开通<span class="blue">个人网银</span>查询服务的银行</div>
    <div class="custom-section">
      <div class="row">
        <div class="block">工商银行</div>
        <div class="spacing"></div>
        <div class="block">建设银行</div>
        <div class="spacing"></div>
        <div class="block">招商银行</div>
      </div>
      <div class="row">
        <div class="block">中信银行</div>
        <div class="spacing"></div>
        <div class="block">浦发银行</div>
        <div class="spacing"></div>
        <div class="empty_block"></div>
      </div>
    </div>
    <div class="text2">目前已开通<span class="blue">个人手机银行</span>查询服务的银行</div>
    <div class="custom-section">
      <div class="row">
        <div class="block">中国银行</div>
        <div class="spacing"></div>
        <div class="block">工商银行</div>
        <div class="spacing"></div>
        <div class="block">建设银行</div>
      </div>
      <div class="row">
        <div class="block">招商银行</div>
        <div class="spacing"></div>
        <div class="block">浦发银行</div>
        <div class="spacing"></div>
        <div class="block">交通银行</div>
      </div>
      <div class="row">
        <div class="block">中信银行</div>
        <div class="spacing"></div>
        <div class="block">光大银行</div>
        <div class="spacing"></div>
        <div class="block">银联云闪付</div>
      </div>
    </div>
    <div class="text2">目前已开通<span class="blue">企业网银</span>查询服务的银行</div>
    <div class="custom-section">
      <div class="row">
        <div class="block">工商银行</div>
        <div class="spacing"></div>
        <div class="block">建设银行</div>
        <div class="spacing"></div>
        <div class="block">农业银行</div>
      </div>
      <div class="row">
        <div class="block">招商银行</div>
        <div class="spacing"></div>
        <div class="block">交通银行</div>
        <div class="spacing"></div>
        <div class="block">浦发银行</div>
      </div>
      <div class="row">
        <div class="block">平安银行</div>
        <div class="spacing"></div>
        <div class="block">渤海银行</div>
        <div class="spacing"></div>
        <div class="empty_block"></div>
      </div>
    </div>
    <div class="text2">目前已开通<span class="blue">企业手机银行</span>查询服务的银行</div>
    <div class="custom-section">
      <div class="row">
        <div class="block">工商银行</div>
        <div class="spacing"></div>
        <div class="block">建设银行</div>
        <div class="spacing"></div>
        <div class="block">农业银行</div>
      </div>
      <div class="row">
        <div class="block">招商银行</div>
        <div class="spacing"></div>
        <div class="block">交通银行</div>
        <div class="spacing"></div>
        <div class="block">平安银行</div>
      </div>
      <div class="row">
        <div class="block">浦发银行</div>
        <div class="spacing"></div>
        <div class="empty_block"></div>
        <div class="spacing"></div>
        <div class="empty_block"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InternetBank.vue'
}
</script>

<style scoped>
.header {
  background-color: #ffffff;
  padding: 10px;
  text-align: left;
}

.back-button {
  background-color: #007BFF;
  color: #ffffff;
  text-decoration: none;
  border: none;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
}

.custom-section {
  margin: 5px;
}

.gray-background-page {
  background-color: #f0f0f0;
  height: 100vh;
  margin: 0;
}

.text {
  color: blue;
  padding: 5px;
  margin: 0 5px;
  background-color: #ffffff;
  font-size: 12px;
  line-height: 1.6;
}

.text2 {
  color: black;
  font-weight: bold;
  text-align: center;
  padding: 10px 0;
  margin: 5px;
  background-color: #ffffff;
  font-size: 12px;
  line-height: 15px;
}

.divider {
  height: 5px;
  background-color: #f0f0f0;
}

.blue {
  color: blue;
}

.row {
  display: flex;
  align-items: center;
}

.block {
  flex: 1;
  background-color: #ffffff;
  padding: 10px;
  margin: 5px 0;
  text-align: center;
  font-size: 12px;
  line-height: 15px;
}

.empty_block {
  flex: 1;
  background-color: #f0f0f0;
  padding: 10px;
  margin: 5px 0;
  text-align: center;
  font-size: 12px;
  line-height: 15px;
}

.spacing {
  width: 10px;
}
</style>
